import React, { forwardRef, useImperativeHandle, useState } from 'react';

import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import MaterialUiPhoneNumber from 'material-ui-phone-number';

import PasswordTextField from './PasswordTextField';

const useStyles = makeStyles(() => ({
  field: {
    '& .MuiFormHelperText-root': {
      bottom: -20,
      position: 'absolute',
      right: 10,
    },
    margin: '4px 0 12px',
  },
}));

const NewTextField = forwardRef(
  (
    {
      autoComplete = 'off',
      autoFocus = false,
      className = '',
      disabled = false,
      fullWidth = true,
      label = '',
      margin = 'normal',
      maxLength,
      multiline = false,
      name,
      onBlur,
      onChange,
      onKeyUp,
      placeholder = '',
      required = false,
      rows,
      size = 'medium',
      type = 'text',
      value = '',
      variant = 'standard',
      inputProps = {},
    },
    ref
  ) => {
    const classes = useStyles();
    const [internalValue, setInternalValue] = useState(value);
    const [error, setError] = useState('');

    const handleChange = (event) => {
      const newValue = event.target ? event.target.value : event;
      setInternalValue(newValue);
      setError('');

      if (onChange) {
        onChange(event);
      }
    };

    useImperativeHandle(ref, () => ({
      clearError: () => setError(''),
      getValue: () => internalValue,
      setError: (message) => setError(message),
      setValue: (newValue) => setInternalValue(newValue),
    }));

    const commonProps = {
      autoComplete,
      autoFocus,
      className: `${className} ${classes.field}`,
      disabled,
      error: !!error,
      fullWidth,
      helperText: error,
      inputProps: { ...inputProps, maxLength },
      label,
      margin,
      name,
      onBlur,
      placeholder,
      required,
      size,
      value: internalValue || '',
      variant,
    };

    if (type === 'password') {
      return <PasswordTextField {...commonProps} onChange={handleChange} onKeyUp={onKeyUp} />;
    }

    if (type === 'phone') {
      return <MaterialUiPhoneNumber {...commonProps} defaultCountry="us" onChange={handleChange} />;
    }

    return <TextField {...commonProps} multiline={multiline} minRows={rows} rows={rows} type={type} onChange={handleChange} onKeyUp={onKeyUp} />;
  }
);

NewTextField.displayName = 'NewTextField';

export default NewTextField;
